// Stripe Configuration for Multiple Environments

const stripeConfigs = {
  development: {
    publishableKey: "pk_test_51Lhg7yCoACz7qHbZLj2wPkbHbUtJDjVJWsBkuNZLzv4f6o6XzkwEXFgr2en8rvIWD0jEXgz8UokywZckH1EqHzdY00cGD4gWOh",
    productKey: "price_1RfgCOCoACz7qHbZgSNU04yl",
    webhookSecret: "whsec_R2xrusBCYFoheSBTsfDzXM3qdffFDBT7",
    environment: "test"
  },
  production: {
    publishableKey: "pk_live_51Lhg7yCoACz7qHbZhzirBgWHH41OZDZYGvQOikO7I0s5kijBkCDxd7R7q8TNBRfgrWu6SkwXxWRtcP6ivH6qQ92O00NVd2bDjO",
    productKey: "price_1RRaITCoACz7qHbZEMwBGsKj",
    webhookSecret: "whsec_E8tibeyaK0rfKRd6OwHVpogOzhiPnkMw",
    environment: "live"
  }
};

// Determine environment based on hostname and environment variables
// This logic should match firebase.config.js exactly
const getEnvironment = () => {
  // Allow explicit override via environment variable
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }

  const hostname = window.location.hostname;

  // Development environments:
  // 1. localhost (local development)
  // 2. Vercel development deployment
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === 'realworld-sightseer-react-userlingers-projects.vercel.app' ||
    hostname === 'realworld-sightseer-react-git-dev-userlingers-projects.vercel.app'
  ) {
    return 'development';
  }

  // Everything else is production
  return 'production';
};

const environment = getEnvironment();
const stripeConfig = stripeConfigs[environment];

// Log environment for debugging
console.log(`[Stripe] Using ${environment} environment`);
console.log(`[Stripe] Hostname: ${window.location.hostname}`);
console.log(`[Stripe] Environment type: ${stripeConfig.environment}`);

export { stripeConfig, environment };
export default stripeConfig;